











import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
import { getDayJsLocale } from "@/helpers/utils";
require("dayjs/locale/sr");
require("dayjs/locale/en");

@Component({})
export default class DateTime extends Vue {
  currTime = "";

  dayJsLocale = "";
  get currDate(): string {
    this.dayJsLocale = getDayJsLocale();
    return dayjs().locale(this.dayJsLocale).format("dddd, MMMM D, YYYY");
  }

  created(): void {
    this.dayJsLocale = getDayJsLocale();

    this.currTime = dayjs().locale(this.dayJsLocale).format("HH:mm");
    setInterval(() => {
      this.currTime = dayjs().format("HH:mm");
    }, 1000);
  }
}
